export const DATE_FORMAT = 'MMM dd, yyyy';
export const DAY_ONLY_FORMAT = 'dd MMM';